import { FuelType } from './FuelType';

export enum BunkeringStatusEnum {
    Unknown = 0,
    Registered = 1,
    Approved = 2,
    Rejected = 3,
    InUse = 4,
    Spent = 5,
    Debunkered = 6,
}
export interface BunkeringEvent {
    id: string;
    eventID: string;
    imoNumber: number;
    bunkeringReference: string;
    fuelType: FuelType;
    bunkeringDateTimeLocal: Date;
    portId: number;
    portCallId: number;
    portUnCode: string;
    portName: string;
    voyageNumber: string;
    debunkering: boolean;
}

export const getStatusName = (status: BunkeringStatusEnum): string => {
    switch (status) {
        case BunkeringStatusEnum.Registered:
            return 'Registered';
        case BunkeringStatusEnum.Approved:
            return 'Approved';
        case BunkeringStatusEnum.Rejected:
            return 'Rejected';
        case BunkeringStatusEnum.InUse:
            return 'In use';
        case BunkeringStatusEnum.Spent:
            return 'Spent';
        case BunkeringStatusEnum.Debunkered:
            return 'Debunkered';
        default:
            return 'Unknown';
    }
};
